import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HomesFacade } from '@library/store/homes/homes.facade';
import { EnumScales } from '@library/store/measures/measures.interface';
import { isDefined } from '@library/utils/helpers/store/is-defined';
import { LocalStorageService } from '@library/utils/services/local-storage.service';
import { ForecastDataLoaderService } from '@pages/control-page/control-page-main/control-page-dashboard/services/forecast-data-loader.service';
import { GraphMeasuresLoaderService } from '@pages/control-page/control-page-main/control-page-dashboard/services/graph-measures-loader.service';
import { PreviewsMeasuresLoaderService } from '@pages/control-page/control-page-main/control-page-dashboard/services/previews-measures-loader.service';
import { ControlPageStore } from '@pages/control-page/control-page-store.service';
import { FeedbackPopupService } from '@pages/control-page/feedback-popup.service';
import { CookieService } from 'ngx-cookie-service';
import { Subscription, firstValueFrom, interval, take } from 'rxjs';

@Component({
  selector: 'app-control-page-dashboard',
  templateUrl: './control-page-dashboard.component.html',
  styleUrls: ['./control-page-dashboard.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    GraphMeasuresLoaderService,
    PreviewsMeasuresLoaderService,
    ForecastDataLoaderService,
  ]
})
export class ControlPageDashboardComponent {

  sub = new Subscription();

  constructor(
    private activatedRoute: ActivatedRoute,
    private cookieService: CookieService,
    private graphMeasuresLoaderService: GraphMeasuresLoaderService,
    private previewsMeasuresLoaderService: PreviewsMeasuresLoaderService,
    private forecastDataLoaderService: ForecastDataLoaderService,
    private homesFacade: HomesFacade,
    private router: Router,
    private localStorage: LocalStorageService,
    private feedbackPopupService: FeedbackPopupService,
    private controlPageStore: ControlPageStore,
  ) {}

  ngOnInit() {
    if (this.activatedRoute.snapshot.queryParams.from_my) {
      this.cookieService.set('from_my', this.activatedRoute.snapshot.queryParams.from_my);
    }

    this.homesFacade.currentHomeId$.subscribe((homeId) => {
      if (homeId && !this.localStorage.getItem('control-fus-seen')) {
        this.router.navigate(['../welcome'], {relativeTo: this.activatedRoute, skipLocationChange: true, queryParamsHandling: 'merge'});
      }
    });

    const fiveMinutes = 60000 * 5;
    this.sub.add(interval(fiveMinutes).subscribe(async () => {
      const homeId = await firstValueFrom(this.homesFacade.currentHomeId$);
      this.homesFacade.loadHomeStatus({home_id: homeId});
    }));

    this.sub.add(this.graphMeasuresLoaderService.subscribe());
    this.sub.add(this.previewsMeasuresLoaderService.subscribe());

    const tenMinutes = 60000 * 10;
    this.sub.add(interval(tenMinutes).subscribe(() => {
      this.graphMeasuresLoaderService.load();
      this.previewsMeasuresLoaderService.load();
    }));

    this.forecastDataLoaderService.load();

    // uncomment if we need a new feedback
    // this.feedbackPopupService.initFeedbackPopup(this.router.url);

    // Wait for home to be loaded so the timezone is set
    this.homesFacade.currentHome$.pipe(
      isDefined(),
      take(1)
    ).subscribe(() => {
      this.controlPageStore.selectScale(EnumScales.DAY);
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
